import { Tab } from "@blueprintjs/core";
import { useApiEffect } from "nsitools-react";
import * as React from "react";
import { useHistory, useParams } from "react-router";

import { CalendrierApi } from "../../../../api";
import { ERoutes } from "../../../../AppRouter";
import { BackButton, PageBase, ProtectedTabs } from "../../../../components";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { CalendrierDetailPage } from "./CalendrierDetailPage";

export interface ICalendrierItemPageProps {}

export const CalendrierItemPage: React.FunctionComponent<ICalendrierItemPageProps> = () => {
  const { t } = useTl();
  const { id, tab } = useParams<{ id: string; tab: string; state: string }>();
  const history = useHistory();

  const api = useApiService(CalendrierApi);

  const [displayName] = useApiEffect(() => api.calendrierGetDisplayName({ id: +id }), [id]);

  return (
    <PageBase
      breadCrumbs={[
        { text: t(ETLCodes.Calendrier), route: `${ERoutes.calendrier}/search` },
        { text: +id <= 0 ? t(ETLCodes.New) : displayName }
      ]}
    >
      <ProtectedTabs
        id="TabsCalendrier"
        onChange={newTabId => history.push(`${ERoutes.calendrier}/${id}/${newTabId}`)}
        selectedTabId={tab}
        renderActiveTabPanelOnly
      >
        <BackButton backRoute={`${ERoutes.calendrier}/search`} />
        <Tab id="detail" title={t(ETLCodes.Detail)} panel={<CalendrierDetailPage />} />
      </ProtectedTabs>
    </PageBase>
  );
};
